import { useEffect } from 'react'
import { fetchMaxSavings, HOMES_AND_VILLAS_FILTER } from 'actions/HomesAndVillasHomepageActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { EmptyObject } from 'lib/object/objectUtils'

type MaxSavingsResult = [Record<string, number | undefined>, boolean];

export function useHomesAndVillasDestinationMaxSavings(
  destinationIds: Array<string>,
): MaxSavingsResult {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchMaxSavings(destinationIds))
  }, [destinationIds, dispatch])

  const maxSavings = useAppSelector(state => state.destination.maxSavings[HOMES_AND_VILLAS_FILTER]) ?? EmptyObject
  const fetching = useAppSelector(state => state.destination.fetchingMaxSavings)

  return [maxSavings, fetching]
}
